import { useMutation } from 'react-query'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { setCashout } from 'services/withDraw'
import posthog from 'posthog-js'

export default function useSetCashouts() {
    const navigate = useNavigate()
    const { isLoading, mutate } = useMutation({
        mutationFn: (payload: IGetCardsPayloadFinal) => {
            return setCashout(payload)
        },
        onSuccess: (data, variables, payload) => {
            toast.success('برداشت با موفقیت ثبت شد')
            posthog.capture('fund_withdrawal_succeeded', {
                method: 'manual_record',
                amount: (variables as any)?.amount,
                reason: (variables as any)?.reason,
                moneypool_id: (variables as any)?.moneyPool,
                // what joins the member's درخواست برداشت to the payout that
                // answered it; absent on an ordinary cash-out
                withdrawal_request: (variables as any)?.withdrawal_request,
            })
            navigate('/funds')
        },
        onError: (error: any, variables) => {
            posthog.capture('fund_withdrawal_failed', {
                method: 'manual_record',
                status: error?.response?.status,
                withdrawal_request: (variables as any)?.withdrawal_request,
            })
            toast.error('خطایی رخ داده!')
        },
    })

    return { isLoading, mutate }
}
